import { render, staticRenderFns } from "./ActionTypeView.vue?vue&type=template&id=20c95e83&scoped=true"
import script from "./ActionTypeView.vue?vue&type=script&lang=js"
export * from "./ActionTypeView.vue?vue&type=script&lang=js"
import style0 from "./ActionTypeView.vue?vue&type=style&index=0&id=20c95e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c95e83",
  null
  
)

export default component.exports